<template>
  <div class="ranking">
    <div class="top-three" v-if="topThree.length > 0">
      <div class="second" v-if="topThree.length > 1">
        <div class="img">
          <van-image shape="circle" :src="imgView(topThree[1].badge)" width="42px" height="42px"></van-image>
        </div>
        <div class="name">
          {{ topThree[1].name }}
        </div>
      </div>
      <div class="first"  v-if="topThree.length > 0">
        <div class="img">
          <van-image shape="circle" :src="imgView(topThree[0].badge)" width="50px" height="50px"></van-image>
        </div>
        <div class="name">
          {{ topThree[0].name }}
        </div>
      </div>
      <div class="third" v-if="topThree.length > 2">
        <div class="img">
          <van-image shape="circle" :src="imgView(topThree[2].badge)" width="37px" height="37px"></van-image>
        </div>
        <div class="name">
          {{ topThree[2].name }}
        </div>
      </div>
    </div>
    <div class="item" v-for="(item, index) in others" :key="index">
      <div class="num">
        {{index + 4}}
      </div>
      <div class="logo">
        <van-image shape="circle" :src="imgView(item.badge)" width="36px" height="36px"></van-image>
      </div>
      <div class="name">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import {getBMMatchRankList} from "@/api/match";
import {QNImageUtil} from "@/utils";

export default {
  name: "Ranking",
  props: {
    matchId: {
      required: true
    }
  },
  mounted() {
    this.getBMMatchRankList()
  },
  data() {
    return {
      topThree: [],
      others: [],
      list: []
    }
  },
  methods: {
    getBMMatchRankList() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchRankList(params).then(res => {
        if (res) {
          const { data } = res
          const list = data.list
          this.topThree = list.slice(0, 3)
          this.others = list.slice(3)
        }
      })
    },
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
  }
}
</script>

<style lang="scss">
.ranking {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
  .top-three {
    border-radius: 8px;
    background-color: #FBFBFC;
    padding: 12px 13px 14px 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .first {
      width: 118px;
      height: 125px;
      background: url("https://images.snsports.cn/FiuJXW9UtOgQ2yRcNsW5nKoI748A") no-repeat;
      background-size: 100% 100%;
      padding-top: 19px;
      box-sizing: border-box;
      .img {
        width: 50px;
        margin: 0 auto;
      }
      .name {
        text-align: center;
        width: 72px;
        margin: 8px 22px 0 23px;
        font-size: 14px;
        font-weight: 500;
        color: #191919;
        overflow:hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .second {
      width: 94px;
      height: 114px;
      background: url("https://images.snsports.cn/Fl3bHV_Buwkz6Qo3-T7SDZ5BjTJ7") no-repeat;
      background-size: 100% 100%;
      padding-top: 15px;
      box-sizing: border-box;
      .img {
        width: 42px;
        margin: 0 29px 0 22px;
      }
      .name {
        text-align: center;
        width: 56px;
        margin: 8px 23px 0 15px;
        font-size: 14px;
        font-weight: 500;
        color: #191919;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .third {
      width: 90px;
      height: 108px;
      background: url("https://images.snsports.cn/FuIFIlJ_U_4f_oulvW6BD9urQFLq") no-repeat;
      background-size: 100% 100%;
      padding-top: 15px;
      box-sizing: border-box;
      .img {
        width: 37px;
        margin: 0 22px 0 29px;
      }
      .name {
        text-align: center;
        width: 56px;
        margin: 8px 14px 0 20px;
        font-size: 14px;
        font-weight: 500;
        color: #191919;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
  .item {
    height: 64px;
    border-radius: 8px;
    background-color: #FBFBFC;
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-top: 12px;
    .num {
      margin: 0 19px 0 17px;
    }
    .logo {
      margin-right: 14px;
    }
    .name {
      font-weight: 500;
      font-size: 14px;
      color: #191919;
      overflow: hidden;
    }
  }
}
</style>
